import "core-js/modules/es.array.find";
// a-form で調整できないスタイルを JS 側で処理

/**
 * セレクトボックスを特定の div で包含する
 */
$('#parts-1').wrap('<div class="p-form-select -sizeL"></div>');
$('#contact-category').wrap('<div class="p-form-select -sizeL"></div>');
$('#recruit-birth-yy').wrap('<div class="p-form-select -sizeS"></div>');
$('#recruit-birth-mm').wrap('<div class="p-form-select -sizeS"></div>');
$('#recruit-birth-dd').wrap('<div class="p-form-select -sizeS"></div>');
/**
 * 不足しているクラスを補完
 */

$('.dl_recruit-birth').find('.p-form-field').addClass('-linear');